<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <div>
    <div class="mainsol">
      <HeaderParts />
      <div class="contents">
        <SolutionPage />
      </div>
    </div>
    <main class="main-content">
      <section class="slideshow">
        <div class="slideshow-inner">
          <div class="slides">
            <!--ネクストジャーニー専用ページ-->
            <div class="slide is-active">
              <div class="slide-content">
                <div class="caption">
                  <div class="title">
                    <!--ネクストジャーニーロゴ-->
                    <img src="../assets/NJLogo.png" alt="nextjourney" class="imagetitle" />
                  </div>
                  <div class="subtitle-main">
                    <p class="ai">AIが導く営業の新時代へ</p>
                  </div>
                  <a href="/nextjourney" target="_blank" class="btn">
                    <span class="btn-inner">NEXT JOURNEY<br>詳細</span>
                  </a>
                  <!-- <button class="bubbly-button" :class="{ animate: isAnimating }" @click="animateButton">
                      Click me!
                    </button> -->
                </div>
              </div>
              <div class="image-container-nj">
                <div class="nj"></div>
                <!-- <img src="https://www.alixbdanthenay.fr/wp-content/uploads/2015/07/Indispensable-1.jpg" alt="" class="image" /> -->
              </div>
              <!--ここまでネクストジャーニー-->
            </div>
            <!--Digital Innovationページ-->
            <div class="slide">
              <div class="slide-content">
                <div class="caption">
                  <div class="title">Digital Innovation</div>
                  <div class="title">×</div>
                  <div class="title">kintone対面開発</div>
                  <div class="text">
                    <p>詳しくは動画をご覧ください</p>
                    <p>BY STAR SYSTEM</p>
                  </div>
                  <a href="https://www.youtube.com/watch?v=5T3XxY7ijbY&t=311s" target="_blank" class="btn">
                    <span class="btn-inner">LOOK More</span>
                  </a>
                  <!-- <a href="#INFORMATION" class="btn">
                      <span class="btn-inner">INFORMATION</span>
                    </a> -->
                </div>
              </div>
              <div class="image-container-navy">
                <div class="navy"></div>
                <!-- <img src="https://www.alixbdanthenay.fr/wp-content/uploads/2015/07/Indispensable-1.jpg" alt="" class="image" /> -->
              </div>
            </div>
            <!--対面開発専用ページ-->
            <div class="slide">
              <div class="slide-content">
                <div class="caption">
                  <div class="title">対面開発</div>
                  <div class="text">
                    <p>kintoneを利用したご提案</p>
                  </div>
                  <a href="https://www.youtube.com/watch?v=5T3XxY7ijbY&t=311s" target="_blank" class="btn">
                    <span class="btn-inner">LOOK More</span>
                  </a>
                </div>
              </div>
              <div class="image-container">
                <img src="../assets/KAIGI.jpg" alt="" class="image" />
                <!-- <img src="https://www.alixbdanthenay.fr/wp-content/uploads/2015/07/Indispensable-4-1.jpg" alt="" class="image" /> -->
              </div>
            </div>
            <!--問い合わせページ-->
            <div class="slide">
              <div class="slide-content">
                <div class="caption">
                  <div class="title">無料診断</div>
                  <div class="text">
                    <p>導入を検討の方はこちら</p>
                  </div>
                  <a href="/tos" class="btn">
                    <span class="btn-inner">CLICK</span>
                  </a>
                </div>
              </div>
              <div class="image-container">
                <img src="../assets/PC.jpg" alt="" class="image" />
              </div>
            </div>
            <!-- <div class="slide">
                <div class="slide-content">
                  <div class="caption">
                    <div class="title">お問合せ</div>
                    <div class="text">
                      <p>導入を検討の方はこちら</p>
                    </div>
                    <a href="#" class="btn">
                      <span class="btn-inner">CLICK</span>
                    </a>
                  </div>
                </div>
                <div class="image-container">
                  <img src="https://www.alixbdanthenay.fr/wp-content/uploads/2016/11/20mars17-sans-typo.jpg" alt="" class="image" />
                </div>
              </div> -->
          </div>
          <div class="pagination">
            <div class="item is-active">
              <span class="icon">1</span>
            </div>
            <div class="item">
              <span class="icon">2</span>
            </div>
            <div class="item">
              <span class="icon">3</span>
            </div>
            <div class="item">
              <span class="icon">4</span>
            </div>
          </div>
          <div class="arrows">
            <div class="arrow prev">
              <span class="svg svg-arrow-left">
                <svg version="1.1" id="svg4-Layer_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="14px" height="26px"
                  viewBox="0 0 14 26" enable-background="new 0 0 14 26" xml:space="preserve">
                  <path
                    d="M13,26c-0.256,0-0.512-0.098-0.707-0.293l-12-12c-0.391-0.391-0.391-1.023,0-1.414l12-12c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414L2.414,13l11.293,11.293c0.391,0.391,0.391,1.023,0,1.414C13.512,25.902,13.256,26,13,26z" />
                </svg>
                <span class="alt sr-only"></span>
              </span>
            </div>
            <div class="arrow next">
              <span class="svg svg-arrow-right">
                <svg version="1.1" id="svg5-Layer_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="14px" height="26px"
                  viewBox="0 0 14 26" enable-background="new 0 0 14 26" xml:space="preserve">
                  <path
                    d="M1,0c0.256,0,0.512,0.098,0.707,0.293l12,12c0.391,0.391,0.391,1.023,0,1.414l-12,12c-0.391,0.391-1.023,0.391-1.414,0s-0.391-1.023,0-1.414L11.586,13L0.293,1.707c-0.391-0.391-0.391-1.023,0-1.414C0.488,0.098,0.744,0,1,0z" />
                </svg>
                <span class="alt sr-only"></span>
              </span>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import HeaderParts from '@/atoms/headerParts.vue';
import SolutionPage from '@/atoms/SolutionPage.vue';
import { ref } from 'vue';

// <script src="../js/Top.js">
// import HelloWorld from './components/HelloWorld.vue'
// import "https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.1/TweenMax.min.js"
// import "https://code.jquery.com/jquery-3.3.1.slim.min.js"

export default {
  // eslint-disable-next-line
  /* eslint-disable */
  name: "HeaderTop",
  components: { SolutionPage, HeaderParts },
  methods: {
    test() {
      var slideshowDuration = 4000;
      var slideshow = $(".main-content .slideshow");
      console.log(slideshowDuration);
      console.log(slideshow);
    },
  },
  mounted() {
    // eslint-disable-next-line
    /* eslint-disable */

    var slideshowDuration = 4000;
    var slideshow = $('.main-content .slideshow');

    function slideshowSwitch(slideshow, index, auto) {
      if (slideshow.data('wait')) return;

      var slides = slideshow.find('.slide');
      var pages = slideshow.find('.pagination');
      var activeSlide = slides.filter('.is-active');
      var activeSlideImage = activeSlide.find('.image-container');
      var newSlide = slides.eq(index);
      var newSlideImage = newSlide.find('.image-container');
      var newSlideContent = newSlide.find('.slide-content');
      var newSlideElements = newSlide.find('.caption > *');
      if (newSlide.is(activeSlide)) return;

      newSlide.addClass('is-new');
      var timeout = slideshow.data('timeout');
      clearTimeout(timeout);
      slideshow.data('wait', true);
      var transition = slideshow.attr('data-transition');
      if (transition == 'fade') {
        newSlide.css({
          display: 'block',
          zIndex: 2
        });
        newSlideImage.css({
          opacity: 0
        });

        TweenMax.to(newSlideImage, 1, {
          alpha: 1,
          onComplete: function () {
            newSlide.addClass('is-active').removeClass('is-new');
            activeSlide.removeClass('is-active');
            newSlide.css({ display: '', zIndex: '' });
            newSlideImage.css({ opacity: '' });
            slideshow.find('.pagination').trigger('check');
            slideshow.data('wait', false);
            if (auto) {
              timeout = setTimeout(function () {
                slideshowNext(slideshow, false, true);
              }, slideshowDuration);
              slideshow.data('timeout', timeout);
            }
          }
        });
      } else {
        if (newSlide.index() > activeSlide.index()) {
          var newSlideRight = 0;
          var newSlideLeft = 'auto';
          var newSlideImageRight = -slideshow.width() / 8;
          var newSlideImageLeft = 'auto';
          var newSlideImageToRight = 0;
          var newSlideImageToLeft = 'auto';
          var newSlideContentLeft = 'auto';
          var newSlideContentRight = 0;
          var activeSlideImageLeft = -slideshow.width() / 4;
        } else {
          var newSlideRight = '';
          var newSlideLeft = 0;
          var newSlideImageRight = 'auto';
          var newSlideImageLeft = -slideshow.width() / 8;
          var newSlideImageToRight = '';
          var newSlideImageToLeft = 0;
          var newSlideContentLeft = 0;
          var newSlideContentRight = 'auto';
          var activeSlideImageLeft = slideshow.width() / 4;
        }

        newSlide.css({
          display: 'block',
          width: 0,
          right: newSlideRight,
          left: newSlideLeft
          , zIndex: 2
        });

        newSlideImage.css({
          width: slideshow.width(),
          right: newSlideImageRight,
          left: newSlideImageLeft
        });

        newSlideContent.css({
          width: slideshow.width(),
          left: newSlideContentLeft,
          right: newSlideContentRight
        });

        activeSlideImage.css({
          left: 0
        });

        TweenMax.set(newSlideElements, { y: 20, force3D: true });
        TweenMax.to(activeSlideImage, 1, {
          left: activeSlideImageLeft,
          ease: Power3.easeInOut
        });

        TweenMax.to(newSlide, 1, {
          width: slideshow.width(),
          ease: Power3.easeInOut
        });

        TweenMax.to(newSlideImage, 1, {
          right: newSlideImageToRight,
          left: newSlideImageToLeft,
          ease: Power3.easeInOut
        });

        TweenMax.staggerFromTo(newSlideElements, 0.8, { alpha: 0, y: 60 }, { alpha: 1, y: 0, ease: Power3.easeOut, force3D: true, delay: 0.6 }, 0.1, function () {
          newSlide.addClass('is-active').removeClass('is-new');
          activeSlide.removeClass('is-active');
          newSlide.css({
            display: '',
            width: '',
            left: '',
            zIndex: ''
          });

          newSlideImage.css({
            width: '',
            right: '',
            left: ''
          });

          newSlideContent.css({
            width: '',
            left: ''
          });

          newSlideElements.css({
            opacity: '',
            transform: ''
          });

          activeSlideImage.css({
            left: ''
          });

          slideshow.find('.pagination').trigger('check');
          slideshow.data('wait', false);
          if (auto) {
            timeout = setTimeout(function () {
              slideshowNext(slideshow, false, true);
            }, slideshowDuration);
            slideshow.data('timeout', timeout);
          }
        });
      }
    }

    function slideshowNext(slideshow, previous, auto) {
      var slides = slideshow.find('.slide');
      var activeSlide = slides.filter('.is-active');
      var newSlide = null;
      if (previous) {
        newSlide = activeSlide.prev('.slide');
        if (newSlide.length === 0) {
          newSlide = slides.last();
        }
      } else {
        newSlide = activeSlide.next('.slide');
        if (newSlide.length == 0)
          newSlide = slides.filter('.slide').first();
      }

      slideshowSwitch(slideshow, newSlide.index(), auto);
    }

    function homeSlideshowParallax() {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > windowHeight) return;
      var inner = slideshow.find('.slideshow-inner');
      var newHeight = windowHeight - (scrollTop / 2);
      var newTop = scrollTop * 0.8;

      inner.css({
        transform: 'translateY(' + newTop + 'px)', height: newHeight
      });
    }

    $(document).ready(function () {
      $('.slide').addClass('is-loaded');

      $('.slideshow .arrows .arrow').on('click', function () {
        slideshowNext($(this).closest('.slideshow'), $(this).hasClass('prev'));
      });

      $('.slideshow .pagination .item').on('click', function () {
        slideshowSwitch($(this).closest('.slideshow'), $(this).index());
      });

      $('.slideshow .pagination').on('check', function () {
        var slideshow = $(this).closest('.slideshow');
        var pages = $(this).find('.item');
        var index = slideshow.find('.slides .is-active').index();
        pages.removeClass('is-active');
        pages.eq(index).addClass('is-active');
      });

      /* Lazyloading
      $('.slideshow').each(function(){
        var slideshow=$(this);
        var images=slideshow.find('.image').not('.is-loaded');
        images.on('loaded',function(){
          var image=$(this);
          var slide=image.closest('.slide');
          slide.addClass('is-loaded');
        });
      */

      var timeout = setTimeout(function () {
        slideshowNext(slideshow, false, true);
      }, slideshowDuration);

      slideshow.data('timeout', timeout);
    });

    if ($('.main-content .slideshow').length > 1) {
      $(window).on('scroll', homeSlideshowParallax);
    }
  },
  computed: {
    animateButton() {
      const isAnimating = ref(false)
      isAnimating.value = false
      // DOMの更新を待つために nextTick を使用せずに、直接 setTimeout を使用
      setTimeout(() => {
        isAnimating.value = true
        setTimeout(() => {
          isAnimating.value = false
        }, 700)
      }, 0)
    }
  },
};
</script>

<style scoped>
@import "../css/top.css";
@import "../css/topscss.css";
@import "../css/animateButton.css";
@import "../css/mainslo.css";

img.imagetitle {
  width: 68%;
}

p.ai {
  font-size: 0.7em;
}

@media screen and (max-width: 600px) {
  img.imagetitle {
    width: 100%;
  }
}
</style>
